// Etiquetas de tarjetas PCF que comparten la pantalla de Tarjetas y la fila PCF de Inventario v3.
import type { SelectOption } from '@/kit';
import { CardStockMovementTypeEnum } from '@fiado/type-kit/bin/retailCards/enums/CardStockMovementTypeEnum';
import { CardWriteOffReasonEnum } from '@fiado/type-kit/bin/retailCards/enums/CardWriteOffReasonEnum';
import type { StatusConfig } from '../components';

/** Etiqueta de cada tipo de asiento; la usan la pantalla Tarjetas y el libro de Inventario. */
export const CARD_MOVEMENT_TYPE_LABEL: Record<CardStockMovementTypeEnum, string> = {
    [CardStockMovementTypeEnum.IN_BATCH]: 'Entrada de lote',
    [CardStockMovementTypeEnum.OUT_DELIVERY]: 'Entrega a cliente',
    [CardStockMovementTypeEnum.OUT_WRITE_OFF]: 'Baja',
    [CardStockMovementTypeEnum.REVERSAL]: 'Reversa',
};

export const CARD_MOVEMENT_TYPES: Record<string, StatusConfig> = {
    [CardStockMovementTypeEnum.IN_BATCH]: {
        label: CARD_MOVEMENT_TYPE_LABEL[CardStockMovementTypeEnum.IN_BATCH],
        variant: 'success',
    },
    [CardStockMovementTypeEnum.OUT_DELIVERY]: {
        label: CARD_MOVEMENT_TYPE_LABEL[CardStockMovementTypeEnum.OUT_DELIVERY],
        variant: 'info',
    },
    [CardStockMovementTypeEnum.OUT_WRITE_OFF]: {
        label: CARD_MOVEMENT_TYPE_LABEL[CardStockMovementTypeEnum.OUT_WRITE_OFF],
        variant: 'destructive',
    },
    [CardStockMovementTypeEnum.REVERSAL]: {
        label: CARD_MOVEMENT_TYPE_LABEL[CardStockMovementTypeEnum.REVERSAL],
        variant: 'warning',
    },
};

export const CARD_WRITE_OFF_REASONS: Record<string, string> = {
    [CardWriteOffReasonEnum.LOST]: 'Extravío',
    [CardWriteOffReasonEnum.PLASTIC_DAMAGED]: 'Plástico dañado',
    [CardWriteOffReasonEnum.STOLEN]: 'Robo',
};

/** Motivos de baja en orden alfabético por su etiqueta, que es lo que el operador lee. */
export const CARD_WRITE_OFF_OPTIONS: SelectOption[] = Object.entries(CARD_WRITE_OFF_REASONS)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es-MX'));

/** Claves RBAC que exige `retail-cards-business` para registrar lotes y dar de baja. */
export const CARD_PERMISSIONS = {
    registerBatch: 'retail.batch.create',
    writeOff: 'retail.stock.write-off',
} as const;
